const transformer = function (origin, defs, rowData) {
  return {
    render: 'gis',
    origin,
    value: {
      origin,
      defs,
      rowData,
    },
  }
}

export default transformer
